<template>
  <div>
    <div class="files">
      <div class="title">
        <div class="title-zw"></div>
        <div class="title-text">我收到的资料</div>
      </div>
      <div>
        <Table class="file-table"
               v-if="filesPassed.length > 0"
               border
               :columns="columns"
               :data="filesPassed">
          <template slot-scope="{ row }"
                    slot="file_size">
            <div>{{ row.file_size ? row.file_size : '0'}}</div>
          </template>
          <template slot-scope="{ row }"
                    slot="upload_user">
            <strong>{{ row.upload_user=='admin' ? '威马捷' : '未知'}}</strong>
          </template>
          <template slot-scope="{ row, index }"
                    slot="action">
            <div v-if="row.type == 2"
                 class="file-btns">
              <Button @click="getDocumentFile(2,row.form_id)"
                      class="state-btn"
                      type="primary">查看</Button>

              <Button type="primary"
                      style="margin-left:10px;"
                      v-if="row.consent_url"
                      @click="downloadFile(row.consent_url)">下载</Button>

            </div>
            <div v-else-if="row.type == 5"
                 class="file-btns">
              <Button @click="checkoutFile(row)"
                      class="state-btn"
                      type="primary"
                      style="margin-right: 5px">支付</Button>
              <Button @click="updata(row)"
                      class="state-btn"
                      type="primary">账单</Button>
            </div>
            <div v-else-if="row.type == 8"
                 class="file-btns">
              <Button type="primary"
                      @click="downloadFile(row.consent_url)">下载</Button>
            </div>
          </template>
        </Table>
        <div class="text-center" v-if="filesPassed.length > 0">
          <Page class-name="pages"
                :total="total"
                prev-text="上一页"
                next-text="下一页"
                show-elevator
                show-total
                :page-size="15"
                @on-change="changePage(2, $event)" />
        </div>
        <template v-else>
          <p class="empty">暂无文件</p>
        </template>
      </div>
      <div class="title">
        <div class="title-zw"></div>
        <div class="title-text">已提交申请书</div>
      </div>
      <div>
        <template v-if="formList.length > 0">
          <Table class="file-table"
                 v-if="formList.length > 0"
                 border
                 :columns="columnsList"
                 :data="formList">
            <template slot-scope="{ row }"
                      slot="title">
              {{row.file_name}}
            </template>
            <template slot-scope="{ row }"
                      slot="patient">
              {{row.patient_name}}
            </template>
            <template slot-scope="{ row }"
                      slot="time">
              {{row.updated_at}}
            </template>
            <template slot-scope="{ row }"
                      slot="operate">

                <Button v-if="row.status == 0"
                        @click="affirmForm(row.id)"
                        type="primary">确认表单</Button>
                <Button v-else
                        @click="checkOutForm(row.id)"
                        type="primary">查看进度</Button>

              <div style="display: inline-block;width: 10px;"></div>
              <Button @click="checkFormPage(row.id)"
                      type="primary">查看表单</Button>
            </template>
          </Table>
          <template v-else>
            <p class="empty">暂无文件</p>
          </template>
          <div class="text-center" v-if="formList.length > 0">
            <Page class-name="pages"
                  :total="total3"
                  prev-text="上一页"
                  next-text="下一页"
                  show-elevator
                  show-total
                  :page-size="15"
                  @on-change="changePage1" />
          </div>
        </template>
        <template v-else>
          <p class="empty">暂无表单</p>
        </template>
      </div>
      <div class="title">
        <div class="title-zw"></div>
        <div class="title-text">自上传资料</div>
      </div>
      <div>
        <p style="text-align: center;margin-bottom: 20px;">如果文件超过50MB，请发送邮件至 imc2012@sina.cn（每次可接收2GB以内的文件），并另行通知威马捷。</p>
        <Upload class="upload"
                :action="baseURL + 'api/v1/web/user_form/user_up_file'"
                :before-upload="handleBeforeUpload"
                :on-success="handleSuccess"
                :headers="headers"
                :max-size="50 * 1024">
          <div style="width: 350px;height: 274px;">
            <!-- <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon> -->
            <img class="upload-icon"
                 :src="upload"
                 alt="">
            <p class="upload-txt">点击添加相关文件</p>
            <p class="upload-txt2">不超过50M</p>
          </div>
        </Upload>
        <!-- :data="uploadParams" -->
      </div>
      <div class="title">
        <!--<div class="title-zw"></div>-->
        <div class="title-text"></div>
      </div>
      <div class="file-list">
        <Table class="file-table"
               v-if="filesDenyed.length > 0"
               border
               :columns="columnsDenyed"
               :data="filesDenyed"
               style="width: 100%;">
          <template slot-scope="{ row }"
                    slot="file_name">
            <div v-if="row.type == 6"
                 class="file-btns">{{row.old_file_name}}</div>
            <div v-else>{{row.file_name}}</div>
          </template>
          <template slot-scope="{ row }"
                    slot="file_size">
            <strong>{{ row.file_size ? row.file_size : '0'}}</strong>
          </template>
          <template slot-scope="{ row }"
                    slot="upload_user">
            <strong>{{ username }}</strong>
          </template>
          <template slot-scope="{ row, index }"
                    slot="actions">
            <!-- 同意书1  合同书2  文档书3 -->
            <div v-if="row.type == 6"
                 class="file-btns">
              <Upload action="/api/v1/web/user_form/user_up_file"
                      :data="{id: row.id}"
                      style="display:inline-block;margin-right: 5px;">
                <!--<Button type="primary">替换</Button>-->
              </Upload>

              <Button type="primary"
                      @click="downloadFile(row.consent_url)">下载</Button>
            </div>
            <div v-if="row.type == 7"
                 class="file-btns">
              <Button class="state-btn"
                      type="primary"
                      @click="downloadFile(row.consent_url)">下载</Button>
            </div>
          </template>
        </Table>
        <div class="text-center" v-if="filesDenyed.length > 0">
          <Page class-name="pages"
                :total="total2"
                prev-text="上一页"
                next-text="下一页"
                show-elevator
                show-total
                :page-size="15"
                @on-change="changePage(1, $event)" />
        </div>
        <template v-else>
          <p class="empty">暂无文件</p>
        </template>
      </div>
    </div>
    <!-- 显示表单 -->
    <Modal v-model="modalFormVisible"
           title="服务进度"
           width="1000px">
      <Steps :current="status"
             class="head-steps">
        <Step v-for="(step, index) in steps"
              :key="index"
              :title="step.title"
              :content="step.info"
              style="width:auto;margin-bottom: 14px;"></Step>
      </Steps>
      <!-- <div class="form-box"
           v-html="formHTML"></div> -->
      <div slot="footer">
      </div>
    </Modal>
    <!-- 显示文档 -->
    <Modal v-model="modalDocumentVisible"
           title="用户文件"
           width="1000px">
      <div v-html="documentHTML"></div>
      <div slot="footer">
      </div>
    </Modal>
    <!-- 显示需要签名的文档 -->
    <Modal v-model="modalDocumentSignVisible"
           title="用户签名"
           width="1000px">
      <div id="model">
        <div class="contract"
             id="contractPage"
             ref="contract"
             style="font-family: SimSun;">
          <h4 style="text-align: center;font-size: 30px;line-height: 50px;color: #000;">健康管理服务合同</h4>
          <p style="font-size: 16px;color: #000;line-height: 2;">委托方
            <span style="display: inline-block;min-width: 60px;border-bottom: 1px solid #000;padding: 0 10px;" class="blank">{{contract.delegate}}</span>与委托受托方北京威马捷国际旅行援助有限责任公司签订本合同，完成健康管理服务条款（以下称“本条款）中约定的本业务（在本条款中约定）；受托方已委托方接受本条款为前提条件，接受该委托（以下称“本合同”）。委托方与受托方确认，本业务为关于下列委托方的治疗等（在第二条中定义）相关的医疗咨询、健康咨询、健康管理等业务。</p>
          <p style="font-size: 16px;color: #000;line-height: 2;">治疗等目的以及方法：
            <span style="display: inline-block;min-width: 60px;border-bottom: 1px solid #000;padding: 0 10px;" class="blank">{{contract.methods}}</span>
          </p>
          <p style="font-size: 16px;color: #000;line-height: 2;">本合同一式两份，双方当事人签字或盖章后各持一份，具有同等法律效力。</p>
          <p style="font-size: 16px;color: #000;line-height: 2;">签订日期：
            <span style="display: inline-block;min-width: 60px;border-bottom: 1px solid #000;padding: 0 10px;" class="blank">{{contract.signing_date}}</span>
          </p>
          <p style="font-size: 16px;color: #000;line-height: 2;">
            委托方：
            <!--<img :src="signImg" alt="" style="width: 80px;" />-->
          </p>
          <p style="font-size: 16px;color: #000;line-height: 2;display: flex;">姓名：
            <span style="display: inline-block;min-width: 60px;border-bottom: 1px solid #000;padding: 0 10px;" class="blank">{{contract.user_name}}</span>
            <span v-if="signImg" style="font-size: 16px;color: #000;line-height: 2;margin-left: 50px;">签字：
              <img :src="signImg"
                   alt=""
                   style="width: 80px;" />
            </span>
          </p>
          <p style="font-size: 16px;color: #000;line-height: 2;">身份证号（或护照号）：
            <span style="display: inline-block;min-width: 60px;border-bottom: 1px solid #000;padding: 0 10px;" class="blank">{{contract.user_id}}</span>
          </p>
          <p style="font-size: 16px;color: #000;line-height: 2;">所在地：
            <span style="display: inline-block;min-width: 60px;border-bottom: 1px solid #000;padding: 0 10px;" class="blank">{{contract.user_address}}</span>
          </p>
          <p style="font-size: 16px;color: #000;line-height: 2;">联系电话：
            <span style="display: inline-block;min-width: 60px;border-bottom: 1px solid #000;padding: 0 10px;" class="blank">{{contract.phone}}</span>
          </p>
          <p style="font-size: 16px;color: #000;line-height: 2;">电子邮箱：
            <span style="display: inline-block;min-width: 60px;border-bottom: 1px solid #000;padding: 0 10px;" class="blank">{{contract.mail}}</span>
          </p>
        </div>
        <div style="font-size: 16px;" v-html="documentHTML"></div>
      </div>

      <template v-if="flagOfFile == 2">
        <div id="signature1">
          <p v-if="!signImg">
            <em>签名区域</em>
          </p>
          <!--<img :src="signImg"-->
               <!--alt=""-->
               <!--style="" />-->
        </div>
        <div class="js-signature"
             v-if="!signImg"
             @touchstart="changeDisabled"
             @click="changeDisabled"
             data-width="400"
             data-height="200"
             data-border="1px solid #cdcdcd"
             data-line-color="#1E1D81"
             data-line-width="4"
             data-auto-fit="false"></div>
        <div slot="footer"
             v-if="!signImg"
             class="singImg">
          <Button type="primary"
                  id="clearBtn"
                  class="btn btn-default"
                  @click="clearCanvas">重写</Button>
          <Button type="primary"
                  id="saveBtn"
                  class="btn btn-default"
                  @click="saveSignature"
                  disabled>确认签约</Button>
        </div>
      </template>
    </Modal>
    <!-- 支付弹窗 -->
    <Modal v-model="modalDocumentPay"
           title="用户支付"
           width="1000px">
      <div class="pay">
        <div class="pay-cell"
             v-for="(way,index) in ways"
             :key="index">
          <h5>{{way.name}}</h5>
          <img v-if="way.img_url" :src="baseURL + 'storage/' + way.img_url"
               alt="">
          <p v-html="setDoctorName(way.describe)"></p>
        </div>
      </div>
    </Modal>
    <!--确认表单提醒-->
    <Modal
            title="确认提交"
            v-model="form"
            @on-ok="submitForm"
            :closable="false">
      <div style="text-align: center;">
        如申请表内容正确无误，请点击【确认】按钮。
        <br/>
        如有需补充或变更的内容，请联系威马捷工作人员。
      </div>
    </Modal>
  </div>
</template>
<script>
import axios from 'axios';
import $ from 'jquery'
import html2canvas from 'html2canvas'
import '../../public/js/jq-signature.js';
import icon from '@/assets/images/files/icon-file.png';
import pdf from '@/assets/images/files/icon-pdf.png';
import upload from '@/assets/images/upload/icon-plus.jpg';
import * as apis from '@/api/files';
import * as other from '@/api/other';
import * as pay from '@/api/mail';
import { baseURL } from '@/api/axios'
import { getLocalStorage } from '@/utils/tools.js'
export default {
  data () {
    return {
      baseURL,
      upload,
      icon,
      pdf,
      flagOfFile: 0,
      columns: [
        {
          title: '文件名',
          key: 'file_name',
          render:(h, params) => {
            return h('div',{
              style: {
                'padding': '10px 0',
              },
            }, params.row.file_name)
          }
        }, {
          title: '文件大小',
          key: 'file_size',
          slot: 'file_size',
        }, {
          title: '上传人',
          key: 'upload_user',
          slot: 'upload_user',
        }, {
          title: '上传日期',
          key: 'created_at',
        }, {
          title: '操作',
          slot: 'action',
          width: 200,
          align: 'center'
        }
      ],
      columnsDenyed: [
        {
          title: '文件名',
          key: 'file_name',
          slot: 'file_name',
          render:(h, params) => {
            return h('div',{
              style: {
                'padding': '10px 0',
              },
            }, params.row.file_name)
          }
        }, {
          title: '文件大小',
          key: 'file_size',
          slot: 'file_size',
        }, {
          title: '上传人',
          key: 'upload_user',
          slot: 'upload_user',
        }, {
          title: '上传日期',
          key: 'created_at',
        }, {
          title: '操作',
          slot: 'actions',
          width: 250,
          align: 'center'
        }
      ],
      columnsList: [
        {
          title: '文件名',
          key: 'id',
          slot: 'title',
          render:(h, params) => {
            return h('div',{
              style: {
                'padding': '10px 0',
              },
            }, params.row.file_name)
          }
        }, {
          title: '就诊人',
          key: 'id',
          slot: 'patient'
        }, {
          title: '更新日期',
          key: 'id',
          slot: 'time'
        }, {
          title: '操作',
          slot: 'operate',
          width: 240,
          align: 'center'
        }
      ],
      filesPassed: [

      ],
      filesDenyed: [

      ],
      signImg: '',
      modalFormVisible: false,
      modalDocumentVisible: false,
      modalDocumentSignVisible: false,
      modalDocumentPay: false,
      // modalContractVisible: false,
      formList: [],
      formHTML: '',
      headers: {
        // "Content-Type": "multipart/form-data",
        Authorization: getLocalStorage('token')
      },
      uploadParams: {
        id: 0   //form id
      },
      documentHTML: '',
      formId: '',     //记录当前行的form_id
      steps: [],
      status: 0,
      contract: {
        delegate: '',
        phone: '',
        user_id: '',
        user_name: '',
        mail: '',
        user_address: '',
        methods: ''
      },
      ways: [],
      contractURL: '',    //合同图片
      total: 0,
      prev_page: '', //上一页
      next_page: '', //下一页
      total2: 0,
      prev_page2: '', //上一页
      next_page2: '', //下一页
      total3: 0,
      prev_page3: '', //上一页
      next_page3: '', //下一页
      form: false,
      id: null,
      username: '',
      isPc: false
    }
  },
  filters: {
    formatTime: function (val) {
      return val.substring(0, 10);
    }
  },
  created () {
    this.$nextTick(() => {
      this.getlocal()
      // this.getSignature()
    })
    this.isIP = this.os();
  },
  mounted () {
    if (localStorage.getItem('username') && localStorage.getItem('username') !== 'null' && localStorage.getItem('username') !== 'undefined') {
      this.username = localStorage.getItem('username')
    } else {
      this.username = '用户'
    }
    this.getUserUploadFiles(1);     //自上传文件
    this.getUserUploadFiles(2);     //管理员发送文件
    this.getFormList();
    //1同意书，2合同，3给用户统一发文档，4明细，5支付页面，6用户自上传文件，7提交表单时上传文件
  },
  destroyed () {
    localStorage.setItem('formLink', '')
  },
  methods: {
    os() {
      var ua = navigator.userAgent.toLowerCase();
      var s;
      s = ua.match(/iPad/i);

      if(s=="ipad")
      {
        return true;
      }
      else{
        return false;
      }
    },
    setDoctorName (name) {
      if (name) {
        return name.replace(/\n/g, "<br/>");
      } else {
        return ''
      }
    },
    toImg () {
      // let opts = {
      //     logging: true, // 启用日志记录以进行调试 (发现加上对去白边有帮助)
      //     allowTaint: true, // 否允许跨源图像污染画布
      //     backgroundColor: null, // 解决生成的图片有白边
      //     useCORS: true, // 如果截图的内容里有图片,解决文件跨域问题
      //     width: window.screen.availWidth,
      //     height: window.screen.availHeight,
      //     windowWidth: document.querySelector('#contractPage').scrollWidth,
      //     windowHeight: document.querySelector('#contractPage').scrollHeight,
      //     x: 0,
      //     y: window.pageYOffset
      // };
      window.scrollTo(0, 0);   //因为滚动条的缘故，在截图之前，将滚动条复位
      // console.log(document.scrollTop,document.contract.scrollTop)
      let p = html2canvas(document.querySelector('#contractPage')).then(canvas => {
        // let p = html2canvas(this.$refs.contract,opts).then(canvas => {
        let imgUrl = canvas.toDataURL('image/png');
        this.contractURL = imgUrl;
        this.contractURL = this.contractURL.replace(/\&/g, "%26");
        this.contractURL = this.contractURL.replace(/\+/g, "%2B");
        return this.contractURL;
        // that.firstFlag = false;
      }).catch(error => {
        console.log(error)
      });
      return p;
    },
    async getUserUploadFiles (status) {
      try {
        let data = {
          status: status
        };
        let res = await apis.getUserFiles(data);
        if (res.code == 200) {
          if (status == 1) {
            this.filesDenyed = res.data.data;
            this.total2 = res.data.total;
            this.next_page2 = res.data.next_page_url;
          } else {
            this.filesPassed = res.data.data;
            this.total = res.data.total;
            this.next_page = res.data.next_page_url;
          }
        } else {
          this.$Message.error(res.data.msg[0])
        }
      } catch (e) {
        console.log(e)
      }
    },
    async changePage (status, index) {
      try {
        console.log(index)
        let data = {
          status: status,
          page: index
        };
        let res = await apis.getUserFiles(data);
        if (res.code == 200) {
          if (status == 1) {
            this.filesDenyed = res.data.data;
            this.total2 = res.data.total;
            this.next_page2 = res.data.next_page_url;
          } else {
            this.filesPassed = res.data.data;
            this.total = res.data.total;
            this.next_page = res.data.next_page_url;
          }
        } else {
          this.$Message.error(res.data.msg[0])
        }
      } catch (e) {
        console.log(e)
      }
    },
    changePage1 (index) {
      this.getFormList(index)
    },
    async getFormList (index = 1) {
      try {
        let data = {
          page: index
        }
        let res = await apis.getUserForm(data);
        if (res.code == 200) {
          this.formList = res.data.data
          this.total3 = res.data.total
          this.next_page = res.data.next_page_url;
        } else {
          this.formList = [];
        }
      } catch (e) {
        console.log(e)
      }
    },
    async getFormStep (id) {
      //获取表单所在状态
      this.steps = [];
      try {
        let data = {
          form_id: id
        }
        let res = await other.getFormStepNow(data);
        if (res.code == 200) {
          Object.keys(res.data.flow).map((item) => {
            this.steps.push({
              title: '',
              info: res.data.flow[item]
            })
          })

          this.modalFormVisible = true;
          this.status = Number(res.data.status) - 1;
        }
      } catch (e) {
        console.log(e)
      }
    },
    async getFormDetail (id) {
      try {
        let data = {
          id: id,
          isPc: this.isIP
        }
        var winRef = window.open("url", "_blank");

        let res = await apis.getUserFormInfo(data);
        var pdfUrl = "https://admin.weimajie.com.cn/"
        if (res.code == 200) {
          console.log(pdfUrl + res.data.url);
          winRef.location = pdfUrl + res.data.url;
          // window.open(pdfUrl + res.data.url, 'block' + Math.floor(Math.random()*(1 - 100) + 100));
          // if (!this.isIP) {
          //   window.open(pdfUrl + res.data.url);
          // } else {
          //   var eleLink = document.createElement('a');
          //   eleLink.download = '表单';
          //   eleLink.style.display = 'none';
          //   eleLink.href = pdfUrl + res.data.url;
          //   document.body.appendChild(eleLink);
          //   eleLink.click();
          //   document.body.removeChild(eleLink);
          // }
        }
      } catch (e) {
        console.log(e)
      }
    },
    checkOutForm (id) {
      // this.getFormDetail(id);
      this.getFormStep(id);
    },
    checkFormPage (id) {
      this.getFormDetail(id);
    },
    async submitForm() {
      try {
        let data = {
          id: this.id
        };
        let res = await apis.affirmForm(data)
        if (res.code == 200) {
          this.getFormList();
        }
      } catch (e) {
        console.log(e)
      }
    },
    affirmForm(id) {
      this.id = id
      this.form = true;
    },
    handleBeforeUpload () {
      if (this.uploadParams.id == 0) {
        this.uploadParams.id = localStorage.getItem('form_id');
      }
    },
    handleSuccess (res, file) {
      if (res.code == 200) {
        this.$Message.success('上传成功！');
        this.getUserUploadFiles(1);     //未处理文件
        this.getUserUploadFiles(2);     //已处理文件
      } else {
        this.$Message.error(res.data.file[0]);
      }
    },
    downloadFile (url) {
      console.log(url)
      console.log(this.baseURL.substr(0, this.baseURL.length - 1) + url)
      window.open(this.baseURL.substr(0, this.baseURL.length - 1) + url)
    },
    async getDocumentFile (id, rowId) {
      //id=2  设置只有合同类型的文件才能签名
      this.flagOfFile = id;
      // $('.js-signature').jqSignature();
      // await this.watchContract(id);
      this.formId = rowId;
      try {
        let data = {
          id: rowId  //用户统一文档
        };
        let res = await apis.getContractDetailInfo(data);
        if (res.code == 200) {
          this.documentHTML = res.data.content;
          this.modalDocumentSignVisible = true;
          console.log(res.data)
          if (res.data.sign_url) {
            // 显示图片字段不为空-显示图片
            this.signImg = 'https://admin.weimajie.com.cn' + res.data.sign_url;
          } else {
            $('.js-signature').jqSignature();
          }
          //给合同的头部字段赋值
          if (res.data.contract.contract) {
            this.contract = JSON.parse(res.data.contract.contract);
          } else {
            this.contract = {
              delegate: '',
              phone: '',
              user_id: '',
              user_name: '',
              mail: '',
              user_address: '',
              methods: ''
            }

          }
        }
      } catch (e) {
        console.log(e)
      }
    },

    async getDocumentFileWithSign (id) {
      //查看合同信息
      // $('.js-signature').jqSignature();
      try {
        let data = {
          id   //用户统一文档
        };
        let res = await apis.getFileToSee(data);
        if (res.code == 200) {
          this.documentHTML = res.data.content;
          this.modalDocumentSignVisible = true;

        }
      } catch (e) {
        console.log(e)
      }
    },
    async checkoutFile (row) {
      //类型为2，查看文件，如果consent_url没值的时候，签名；有值就是展示url
      ///api/v1/web/user_form/user_consent_form?id=2
      ///api/v1/web/user_form/upload_consent_image  提交签名图片
      if (row.type == 2) {     //查看文件
        if (row.consent_url) {

        } else {  //文件签名
          this.getDocumentFile(2);
          this.formId = row.form_id;
        }
      } else if (row.type == 5) {    //支付
        // await this.getPayMessage(row.internal_mail_content_id);
        await this.getPayType(row.internal_mail_content_id);
        this.modalDocumentPay = true;
      }
      this.getUserUploadFiles(1);     //未处理文件
      this.getUserUploadFiles(2);     //已处理文件
    },
    updata (row) {
      // this.getPayMessage2(row.internal_mail_content_id);
      this.downloadFile(row.consent_url);
      this.getUserUploadFiles(1);     //未处理文件
      this.getUserUploadFiles(2);     //已处理文件
    },
    clearCanvas () {
      $('#signature').html('<p><em>点击确认签名保存</em></p>');
      $('.js-signature').eq(0).jqSignature('clearCanvas');
      $('#saveBtn').attr('disabled', true);
    },
    formhtml () {
      var oldHTML = $.fn.html;
      $.fn.formhtml = function () {
        if (arguments.length) return oldHTML.apply(this, arguments);
        $("input,textarea,button", this).each(function () {
          this.setAttribute("value", this.value);
        });
        $(":radio,:checkbox", this).each(function () {
          if (this.checked) this.setAttribute("checked", "checked");
          else this.removeAttribute("checked");
        });
        $("option", this).each(function () {
          if (this.selected)
            this.setAttribute("selected", "selected");
          else this.removeAttribute("selected");
        });
        $("textarea", this).each(function () {
          this.innerHTML = this.value;
        });
        return oldHTML.apply(this);
      };
      let str = $("#contractPage").formhtml();

      return str;
    },
    async saveSignature () {
      $('#signature').empty();
      var dataUrl = $('.js-signature').eq(0).jqSignature('getDataURL');
      // var img = $('<img>').attr('src', dataUrl);
      // console.log(dataUrl);

      $('#signature').append($('<p>').text("你的签名:"));
      // $('#signature').append(img);

      var imgs = dataUrl;

      imgs = imgs.replace(/\&/g, "%26");
      imgs = imgs.replace(/\+/g, "%2B");
      let contract = this.formhtml()
      console.log(contract, '-------');
      try {
        let data = {
          src_a: contract,
          src_b: imgs,
          form_id: this.formId
        };
        let res = await apis.uploadSignatureImg(data);
        if (res.code == 200) {
          this.$Message.success('签字成功！');
          this.modalDocumentSignVisible = false;

          this.getUserUploadFiles(1);     //未处理文件
          this.getUserUploadFiles(2);     //已处理文件
        }
      } catch (e) {
        console.log(e)
      }



    },
    changeDisabled () {
      // $('.js-signature').trigger('jq.signature.changed');
      // $('.js-signature').eq(0).on('jq.signature.changed', function() {
      $('#saveBtn').attr('disabled', false);
      // });
    },
    //支付相关
    async getPayMessage (id) {
      try {
        let data = {
          id: id
        };
        let res = await pay.getPayMail(data);
        if (res.code == 200) {
          // this.ways = res.data.pay_type.split(',');
          this.amount = res.data.amount;
        }
      } catch (e) {
        console.log(e)
      }
    },
    //支付相关
    async getPayMessage2 (id) {
      try {
        let data = {
          id: id
        };
        let res = await pay.getPayMail(data);
        if (res.code == 200) {
          console.log(res.data.file);
          console.log(this.baseURL.substr(0, this.baseURL.length - 1) + res.data.file);
          window.open(this.baseURL.substr(0, this.baseURL.length - 1) + res.data.file);
          // window.open('https://admin.weimajie.com.cn' + res.data.file)
          // window.open(this.baseURL.substr(0, this.baseURL.length - 1) + res.data.file)
        }
      } catch (e) {
        console.log(e)
      }
    },
    async getPayType (id) {
      try {
        let data = {
          id
        };
        let res = await pay.getPayType(data);
        if (res.code == 200) {
          this.ways = res.data;
        }
      } catch (e) {
        console.log(e)
      }
    },
    getlocal () {
      let id = localStorage.getItem('formLink')
      let elm = document.getElementById(id)
      if (id) {
        elm.scrollIntoView(true)
      }
    },
    // 获取签名
    async getSignature () {
      let res = await apis.getContractDetailInfo(data);
      if (res.code == 200 && res.data.sign_url) {
        this.signImg = res.data.sign_url;
      }
    }
  }
}
</script>
<style lang="less" scoped>
  .js-signature {
    cursor:pointer;
  }
.files {
  width: 970px;
  background: #fff;
  padding: 26px 30px;
  margin: 50px auto;
  h5 {
    font-size: 32px;
    color: #333130;
    line-height: 40px;
    font-weight: normal;
    margin-bottom: 20px;
  }
}
.file-table {
  margin-bottom: 20px;
}
.file-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 20px 0;
  .file-icon {
    width: 40px;
    height: 34px;
  }
  .file-name {
    width: 200px;
    background: #f1f1f1;
    color: #2f2f2f;
    font-size: 22px;
    line-height: 40px;
    text-align: center;
  }
  .file-size {
    width: 80px;
    background: #f1f1f1;
    color: #848484;
    font-size: 22px;
    line-height: 40px;
    text-align: center;
  }
  .file-upload-time {
    width: 136px;
    background: #f1f1f1;
    color: #848484;
    font-size: 22px;
    line-height: 40px;
    text-align: center;
  }
  .file-uploader {
    width: 142px;
    background: #f1f1f1;
    color: #2f2f2f;
    font-size: 22px;
    line-height: 40px;
    text-align: center;
  }
  .file-btns {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    width: 285px;
    button {
      flex: 1;
      margin: 0 4px;
    }
    .state-btn {
      background: #3d3d3d;
      border-color: #3d3d3d;
    }
  }
}
.text-overflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.file-list {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.file-cell {
  width: 160px;
  margin-bottom: 26px;
  img {
    width: 122px;
    height: 128px;
    margin-bottom: 26px;
  }
  p {
    font-size: 26px;
    color: #848484;
    line-height: 30px;
    text-align: center;
  }
}
.empty {
  font-size: 20px;
  line-height: 40px;
  margin-bottom: 40px;
}
.form-list {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  font-size: 20px;
  line-height: 40px;
  text-indent: 10px;
  background: #ccc;
  margin-bottom: 10px;
  .form-name {
    flex: 1;
  }
}
.upload {
  width: 350px;
  /*height: 274px;*/
  background: #f6f6f6;
  border-radius: 4px;
  text-align: center;
  margin: 0 auto;
}
.upload-icon {
  width: 66px;
  height: 66px;
  margin-top: 54px;
  margin-bottom: 30px;
}
.upload-txt {
  font-size: 22px;
  color: #333130;
  line-height: 28px;
  margin-bottom: 10px;
}
.upload-txt2 {
  font-size: 22px;
  color: #898888;
  line-height: 28px;
}
.head-steps {
  width: 96%;
  margin: 50px 2%;
}
.contract {
  h4 {
    text-align: center;
    font-size: 30px;
    line-height: 50px;
  }
  p {
    font-size: 16px;
    color: #000;
    line-height: 2;
  }
}
.blank {
  display: inline-block;
  min-width: 60px;
  border-bottom: 1px solid #000;
  padding: 0 10px;
}
.pay {
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: row;
  margin: 30px 0 100px;
  .pay-cell {
    width: 310px;
    min-height: 364px;
    background: #fff;
    text-align: center;
    color: #3a3a3a;
    padding-top: 30px;
    h5 {
      font-size: 24px;
      margin-bottom: 20px;
    }
    img {
      width: 110px;
      margin-bottom: 50px;
    }
    p {
      font-size: 22px;
      line-height: 24px;
      margin-bottom: 26px;
    }
  }
}

.pay-amount {
  font-size: 30px;
  line-height: 50px;
  text-align: center;
}
</style>
<style lang="less">
.form-box .ivu-form-item-content {
  input[type='text'] {
    width: 100% !important;
  }
}
.form-box {
  // background:red;
  .ivu-form-item-content input[type='text'].gjselect {
    width: 333px !important;
  }
  .gj .ivu-form-item {
    display: inline-block;
  }
  .gj .ivu-form-item:last-child {
    .ivu-form-item-content {
      margin-left: 97px !important;
    }
  }
  .Muy .ivu-form-item-content input[type='text'] {
    width: 228px !important;
  }
  .diagnosis .ivu-form-item-content input[type='text'] {
    width: 680px !important;
  }
  .tas .ivu-col-span-8 {
    width: 32%;
  }
  .page-head {
    height: 80px;
    background: #ae1e10;
    color: #fff;
    text-align: center;
    margin-bottom: 34px;
    h3 {
      font-size: 30px;
      line-height: 50px;
    }
    p {
      font-size: 18px;
    }
  }
}
.text-center {
  display: flex;
  justify-content: center;
}
  .title {
    display: flex;
    font-size: 32px;
    align-items: center;
    margin-bottom: 20px;
  }
  .title-text {

  }
  .title-zw {
    width: 10px;
    height: 10px;
    margin-right: 5px;
    background: #ae1e10;
  }
</style>

